import { useAtomValue } from "jotai";
import { FC, useCallback } from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../../components/button";
import { useHasPermission } from "../../../components/permission";
import { ParticipationsService } from "../../../store/participations/service";
import { selectedLaunch } from "./atoms";

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  & > *:not(:last-child) {
    margin-right: 1em;
  }
`;

export const WidgetAdornment: FC<{
  allLaunches?: { id: string; launchName: string }[];
}> = ({ allLaunches }) => {
  const launch = useAtomValue(selectedLaunch);
  const hasPermission = useHasPermission(["ROLE_ADMIN", "ROLE_MERCHANT"]);

  const downloadCsv = useCallback(() => {
    if (!launch) {
      ParticipationsService.downloadCsv(allLaunches);
    } else {
      ParticipationsService.downloadCsv([launch]);
    }
  }, [launch]);

  return hasPermission ? (
    <ButtonWrapper>
      <PrimaryButton variant="outlined" icon="export" onClick={downloadCsv}>
        Export to CSV
      </PrimaryButton>
    </ButtonWrapper>
  ) : null;
};
